import React from "react";
import moment from "moment";
const ToastContext = React.createContext();
const { Provider, Consumer } = ToastContext;

// TODO: Document it
class ToastContextProvider extends React.Component {

  constructor(props) {
    super(props);

    this.showToast     = this.showToast.bind(this);
    this.onToastShowed = this.onToastShowed.bind(this);
    this.hideToast     = this.hideToast.bind(this);
    this.onToastHidden = this.onToastHidden.bind(this);

    this.state = {};
  }

  showToast(type, message, params) {
    let key = moment().unix();
    this.setState({
      toast: {
        type: type,
        message: message,
        params: params,
        key: key
      },
      toastShowed: true
    })
  }

  onToastShowed() {

  }

  hideToast() {
    this.setState({
      toastShowed: false
    })
  }

  onToastHidden() {
    this.setState({
      toast: undefined,
      toastShowed: false
    })
  }

  render() {
    const { children } = this.props;

    const { toast, toastShowed } = this.state;

    return <Provider value = { {
        toast: toast,
        toastShowed: toastShowed,
        showToast: this.showToast,
        onToastShowed: this.onToastShowed,
        hideToast: this.hideToast,
        onToastHidden: this.onToastHidden
      } } >
      { children }
    </Provider>
  }
}

export { ToastContext, ToastContextProvider, Consumer as ToastContextConsumer };

